/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Save_Up_To_60Inputs */

const en_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save up to 60%`)
};

const de_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu 60% sparen`)
};

const fr_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Économise jusqu'à 60%`)
};

const es_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra hasta 60%`)
};

const it_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmia fino al 60%`)
};

const nl_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespaar tot 60%`)
};

const pl_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oszczędź do 60%`)
};

const fi_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästä jopa 60%`)
};

const da_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spar op til 60%`)
};

const sv_pricing_save_up_to_60 = /** @type {(inputs: Pricing_Save_Up_To_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara upp till 60%`)
};

/**
* | output |
* | --- |
* | "Save up to 60%" |
*
* @param {Pricing_Save_Up_To_60Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_save_up_to_60 = /** @type {((inputs?: Pricing_Save_Up_To_60Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Save_Up_To_60Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_save_up_to_60(inputs)
	if (locale === "fr") return fr_pricing_save_up_to_60(inputs)
	if (locale === "es") return es_pricing_save_up_to_60(inputs)
	if (locale === "it") return it_pricing_save_up_to_60(inputs)
	if (locale === "nl") return nl_pricing_save_up_to_60(inputs)
	if (locale === "pl") return pl_pricing_save_up_to_60(inputs)
	if (locale === "fi") return fi_pricing_save_up_to_60(inputs)
	if (locale === "da") return da_pricing_save_up_to_60(inputs)
	if (locale === "sv") return sv_pricing_save_up_to_60(inputs)
	return en_pricing_save_up_to_60(inputs)
});